import { resolveBlockDisplay } from "@cohesive/ui-components";

/**
 * An HTML block carries ONE thing a document does not: Expand, the canvas
 * lightbox, in its menus. It opens, shares, publishes, promotes and downloads
 * exactly like a document — the record carries its display facts wherever it
 * goes. Every action surface asks that question through this one helper, so
 * the toolbar, the menus, the pane header and the rail cannot drift apart.
 *
 * Two sources, read the way the node router reads them (`resolveBlockDisplay`):
 *   - the record's own `display.mode` — the source of truth, carried by the
 *     api client — wins whenever the record is in;
 *   - the canvas node's synced display copy (`data.display`, or the legacy
 *     `data.presentation` marker) stands in while it is not. Blocks from
 *     before display metadata existed have neither and read as documents.
 */
export function isCanvasIntrinsicRecord({
  record,
  nodeData,
}: {
  record?: { display?: { mode?: string } } | null;
  nodeData?: unknown;
}): boolean {
  return resolveBlockDisplay(record, nodeData)?.mode === "block";
}
